<template lang="pug">
  .app-container#container
    container-main(v-if="isLogin && !isReg && !isMobile")
      router-view
    container-main-mobile(v-else-if="isLogin && !isReg && isMobile")
      router-view
    router-view(v-else)

</template>

<script>
export default {
  data() {
    return {

    };
  },
  computed: {
    isLogin() {
      return this.$store.getters.isLogin;
    },
    isReg() {
      const name = this.$route.name;
      return name && name.match(/reg/);
    },
    isMobile() {
      return window.browserInfo.isMobile;
    },
  },
  created() {
    if (window.location.search) {
      window.location.replace(
        `${window.location.origin}${window.location.pathname}${window.location.hash}${window.location.search}`
      );
    }

    this.$store.watch(({ loginStatus }) => {
      if (loginStatus === null) {
        this.$router.replace({ path: "/login", query: this.$route.query });
        setTimeout(() => {
          location.reload();
        }, 1 * 100);
      }
    });
  },
  mounted() {
    // setInterval(() => {
    if (this.$route.query.verify && this.$route.query.verify == 1) {
      localStorage.setItem("verify", 1);
      this.isShow = false;
    }
    // }, 2000);
  },
};
</script>

<style lang="less">
@import "./theme/index.css";
@import "./assets/general";
@import "./assets/element-RFWallet-mch";

.gl-tip {
  .el-dialog__headerbtn {
    display: none;
  }
  .txt-right {
    text-align: right;
  }
}
.container-content {
  .border-box;
  .flex();

  width: auto;
  height: e("calc(100% - 70px)");
  min-width: 800px;
}
.container-pagination {
  margin-top: 20px;
}

.container-menu {
  .overflow-auto;

  width: 200px;
  min-width: 200px;
  background: @background-menu;
}

.container-router-view {
  .flex(space-between, normal, column);
  .max-width;
  .overflow-auto;
}

.container-padding {
  padding: 0 20px;
}

.container-copyright {
  .flex(space-between, center, column);
  .align-center;

  margin: 1em;
  font-size: 12px;
  color: @font-color-grey;
}

h1 {
  margin: 0;
  color: @font-color-white;
  font-size: @font-size-big;
}

h2 {
  margin: 0 0 10px 0;
}

.toolbar,
.dialog-footer {
  button {
    margin-right: 20px;

    &:last-child {
      margin-right: 0;
    }
  }
  .fr {
    button {
      margin-left: 20px;
      margin-right: 0;

      &:first-child {
        margin-left: 0;
      }
    }
  }
}
.row-toolbox,
.dialog-footer {
  .align-center;
}
.search-input {
  width: 300px;
  line-height: initial;
}
.toolbar {
  margin-bottom: 10px;
}

.imgUploadList,
.uploadList {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    .display-inline-block;
    position: relative;

    button {
      .display-none;
      .position-absolute;
      right: 0;
    }

    &:hover button {
      .display-block;
    }

    .image {
      .display-inline-block;
      height: 100px;
      width: 100px;

      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;

      &:hover {
        .cursor-pointer;
      }
    }
  }
}
.imgView {
  .display-block;
  margin: 0 auto;
  max-width: 100%;
}
.img-container {
  .position-relative;
  .display-inline-block;
  height: 100px;
  width: 100px;
  margin-right: 10px;

  &:hover .img-delete {
    color: @white;
    background: @background-red;
    border-color: @background-red;
    cursor: pointer;
  }
}
.img-delete {
  .flex(center, center);
  .position-absolute;
  right: 4px;
  top: 4px;
  width: 16px;
  height: 16px;
  font-size: 12px;
  color: @grey;
  background: transparent;
  border: 1px solid @grey;
  border-radius: 8px;
}
.img-thumbnail {
  .display-inline-block;
  height: 100px;
  width: 100px;
  object-fit: contain;
}

.mch-image {
  .cursor-pointer;
  max-width: 100%;
  height: 200px;
  object-fit: contain;
}

.binding-container {
  @media screen and (max-width: 500px) {
    .flex(center, space-between, row);
  }
}

.iframeBox {
  .max-height;
  min-height: 500px;
  padding: 0 !important;
}
.iframe {
  border: none;
  .max-width;
  .max-height;
}

.small {
  font-size: 12px;
}
.big {
  font-size: 18px;
}
.huge {
  font-size: 24px;
}

.dialog-footer {
  .align-center;
}

.purple {
  color: @background-blue;
}
.orange {
  color: @background-orange;
}

.data-block {
  margin-bottom: 15px;
}

.auth-app-icon-haofang {
  background-image: url("/haofang.jpg");
}
.auth-app-icon-jifen {
  background-image: url("/jilibao.jpg");
}
.auth-app-icon-shequ {
  background-image: url("/shequ.jpg");
}
</style>
